import React from 'react'
import styled from '@emotion/styled'
import { Tooltip } from '@retailer-platform/shared-components'
import { InformationIcon } from '@instacart/ids-core'
import { useDomainMessage } from 'domains/shifts/utils/domain/intl'

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  margin: '30px 0',
})

const Container = styled.div({
  display: 'flex',
  flexDirection: 'row',
  height: '34px',
  width: '720px',
  boxShadow: `0px 2px 8px rgba(0, 0, 0, 0.16)`,
  borderRadius: '8px',
  justifyContent: `space-evenly`,
})

const LegendItem = styled.div({
  display: 'flex',
  flex: '0 1 auto',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '12px',
})

const ColorBox = styled.span({
  height: '16px',
  width: '16px',
  border: '2px solid',
  borderRadius: '4px',
  marginRight: '6px',
})
const Label = styled.span({
  fontWeight: 600,
  marginRight: '3px',
})

const IconWrapper = styled.span({
  ':hover svg': {
    fill: '#72767e',
  },
})

export const StaffingColorLegend = () => {
  const understaffedMesssage = useDomainMessage('shiftsDomain.legend.understaffed')
  const understaffedTooltipMesssage = useDomainMessage('shiftsDomain.legend.understaffed.tooltip')
  const overstaffedMesssage = useDomainMessage('shiftsDomain.legend.overstaffed')
  const overstaffedTooltipMesssage = useDomainMessage('shiftsDomain.legend.overstaffed.tooltip')
  const optimalMesssage = useDomainMessage('shiftsDomain.legend.optimal')
  const optimalTooltipMesssage = useDomainMessage('shiftsDomain.legend.optimal.tooltip')
  const noneMesssage = useDomainMessage('shiftsDomain.legend.none')
  const noneTooltipMesssage = useDomainMessage('shiftsDomain.legend.none.tooltip')
  return (
    <Wrapper>
      <Container>
        <LegendItem>
          <ColorBox style={{ borderColor: '#AE1D1C', background: '#FAE1E1' }} />
          <Label style={{ color: '#AE1D1C' }}>{understaffedMesssage}</Label>
          <Tooltip
            target={
              <IconWrapper>
                <InformationIcon size={16} color={'systemGrayscale30'} />
              </IconWrapper>
            }
          >
            {understaffedTooltipMesssage}
          </Tooltip>
        </LegendItem>
        <LegendItem>
          <ColorBox style={{ borderColor: '#BB5C05', background: '#FCEAD9' }} />
          <Label style={{ color: '#BB5C05' }}>{overstaffedMesssage}</Label>
          <Tooltip
            target={
              <IconWrapper>
                <InformationIcon size={16} color={'systemGrayscale30'} />
              </IconWrapper>
            }
          >
            {overstaffedTooltipMesssage}
          </Tooltip>
        </LegendItem>
        <LegendItem>
          <ColorBox style={{ borderColor: '#098A09', background: '#DAF3DA' }} />
          <Label style={{ color: '#098A09' }}>{optimalMesssage}</Label>
          <Tooltip
            target={
              <IconWrapper>
                <InformationIcon size={16} color={'systemGrayscale30'} />
              </IconWrapper>
            }
          >
            {optimalTooltipMesssage}
          </Tooltip>
        </LegendItem>
        <LegendItem>
          <ColorBox style={{ borderColor: '#343538', background: '#E8E9EB' }} />
          <Label style={{ color: '#343538' }}>{noneMesssage}</Label>
          <Tooltip
            target={
              <IconWrapper>
                <InformationIcon size={16} color={'systemGrayscale30'} />
              </IconWrapper>
            }
          >
            {noneTooltipMesssage}
          </Tooltip>
        </LegendItem>
      </Container>
    </Wrapper>
  )
}
